import { render, staticRenderFns } from "./PasswordFind.vue?vue&type=template&id=72047dae&scoped=true&"
import script from "./PasswordFind.vue?vue&type=script&lang=js&"
export * from "./PasswordFind.vue?vue&type=script&lang=js&"
import style0 from "./PasswordFind.vue?vue&type=style&index=0&id=72047dae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72047dae",
  null
  
)

export default component.exports